import { range } from "lodash"
import { CCUtils } from "../../../common/CCUtils"
import { StudentStoreSA } from "../../../react/students/StudentStoreSA"
import { MakeVideoChoiceStore } from "./MakeVideoTypes"

export class MakeAVideoStore {

    private static innerInstance: MakeAVideoStore

    private static get key() {
        return CCUtils.debug ? "make-video-testing-key" : `MAKE_VIDEO-${StudentStoreSA.instance.student.id}`
    }

    private store: MakeVideoChoiceStore = {
        music: "",
        videos: range(8).map(() => ""),
        title: "",
        background: 0
    }

    static get instance() {
        return this.innerInstance || (this.innerInstance = new this())
    }

    static newInstance() {
        return this.innerInstance = new this()
    }

    get music(): string {
        return this.getFromLocalStore().music
    }

    set music(music: string) {
        this.store.music = music
        this.saveToLocalStorage()
    }

    get videos(): Array<string> {
        return this.getFromLocalStore().videos
    }

    set video(video: { index: number, clip: string }) {
        const {index, clip} = video
        if (index >= 0 && index < 8) {
            this.store.videos[index] = clip
            this.saveToLocalStorage()
        }
    }

    get title(): string {
        return this.getFromLocalStore().title
    }

    set title(title: string) {
        this.store.title = title
        this.saveToLocalStorage()
    }

    get background(): number {
        return this.getFromLocalStore().background
    }

    set background(background: number) {
        this.store.background = background
        this.saveToLocalStorage()
    }

    private saveToLocalStorage = () => localStorage.setItem(MakeAVideoStore.key, JSON.stringify(this.store))

    private getFromLocalStore = (): MakeVideoChoiceStore => JSON.parse(localStorage.getItem(MakeAVideoStore.key)) as MakeVideoChoiceStore
}
